export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20minimalist%20flatlay%20composition%20featuring%20arranged%20fashion%20accessories%20including%20a%20leather%20watch%20tan%20leather%20bag%20folded%20cream%20knitwear%20and%20stylish%20sunglasses%20on%20a%20warm%20sand%20colored%20textured%20surface%2C%20soft%20diffused%20natural%20lighting%20from%20above%20creating%20gentle%20shadows%2C%20editorial%20lifestyle%20product%20photography%20with%20organic%20arrangement%20and%20generous%20negative%20space%2C%20warm%20earthy%20beige%20cream%20and%20sand%20tones%2C%20elevated%20aesthetic%20with%20sophisticated%20balanced%20composition&width=1600&height=900&seq=hero-bg-vigorbuy-02&orientation=landscape"
          alt="Vigorbuy Spreadsheet fashion product collection background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 py-16 md:py-20 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm border border-background-200/50 mb-6">
            <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
            <span className="text-xs md:text-sm font-medium text-foreground-700 whitespace-nowrap">Updated 2026 Vigorbuy Spreadsheet Resources</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-extrabold text-background-50 leading-tight mb-5">
            Vigorbuy Spreadsheet
            <br />
            <span className="text-primary-400">Ultimate Product Guide</span>
            {" "}& Shopping Resource
          </h1>

          <p className="text-sm md:text-base text-background-100/90 leading-relaxed max-w-xl mx-auto mb-8">
            Discover updated Vigorbuy Spreadsheet collections, product comparisons, buying guides, QC tips, and expert recommendations — all in one trusted resource center designed to help you shop smarter and faster.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-2 px-7 py-3.5 rounded-xl bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap no-underline shadow-lg shadow-primary-500/25"
            >
              <i className="ri-shopping-cart-line text-lg"></i>
              <span>Vigorbuy Spreadsheet</span>
            </a>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-2 px-7 py-3.5 rounded-xl bg-accent-500 text-background-50 text-sm md:text-base font-semibold hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap no-underline shadow-lg shadow-accent-500/25"
            >
              <i className="ri-flashlight-line text-lg"></i>
              <span>Buy It Now</span>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 mt-8 text-background-100/80 text-xs md:text-sm">
            <div className="flex items-center gap-1.5">
              <i className="ri-check-line text-primary-400"></i>
              <span className="whitespace-nowrap">Updated Resources</span>
            </div>
            <div className="flex items-center gap-1.5">
              <i className="ri-check-line text-primary-400"></i>
              <span className="whitespace-nowrap">Detailed Product Guides</span>
            </div>
            <div className="flex items-center gap-1.5">
              <i className="ri-check-line text-primary-400"></i>
              <span className="whitespace-nowrap">Easy Category Search</span>
            </div>
            <div className="flex items-center gap-1.5">
              <i className="ri-check-line text-primary-400"></i>
              <span className="whitespace-nowrap">Safety Information</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#what-is"
          className="flex flex-col items-center gap-2 text-background-100/70 hover:text-background-50 transition-colors cursor-pointer no-underline"
        >
          <span className="text-xs font-medium">Scroll to Explore</span>
          <div className="w-6 h-10 rounded-full border-2 border-background-100/40 flex items-start justify-center p-1.5">
            <div className="w-1.5 h-3 rounded-full bg-background-50 animate-bounce"></div>
          </div>
        </a>
      </div>
    </section>
  );
}